export default __webpack_public_path__ + "static/media/894.20369331.jpg";